function getPath(fieldPath: string, obj: any, mustExist: boolean = true) {
  const path = fieldPath.split('.')
  let res = null
  try {
    if (path.length <= 1) {
      res = obj[fieldPath]
    } else {
      let leaf = obj[path[0]]
      for (let i = 1; i < path.length; i++) {
        leaf = leaf[path[i]]
        if (!leaf) {
          break
        }
      }
      res = leaf
    }
  } catch (e) {
    // nothing here, we will see if we have to fail based on mustExist
  }
  if (mustExist && !res) {
    console.error(`Path ${fieldPath} doesnt exist on`, obj)
    throw Error(`Path ${fieldPath} doesnt exist on ${obj}`)
  }
  return res
}

function cloneObject(obj: any) {
  var clone = {} as any
  for (var i in obj) {
    if (obj[i] != null && typeof obj[i] === 'object')
      clone[i] = cloneObject(obj[i])
    else clone[i] = obj[i]
  }
  return clone
}

export { getPath, cloneObject }
